Shopify.UIHelpers = {
  spinner: {
    show: (selector) => {
      document.querySelectorAll(selector).forEach(container => {
        const spinnerElement = document.createElement('span');
        spinnerElement.classList.add('spinner');

        container.append(spinnerElement);
      });
    },

    hidden: (selector) => {
      document.querySelectorAll(selector).forEach(container => {
        container.querySelector('.spinner')?.remove();
      });
    }
  },
  button: {
    lock: (element) => {
      element?.setAttribute('disabled', '');
    },

    unlock: (element) => {
      element?.removeAttribute('disabled');
    }
  }
};

document.addEventListener('DOMContentLoaded', () => {
  class CustomFacetLinkClearFilters extends HTMLAnchorElement {
    constructor() {
      super();
      this.addEventListener('click', this._closeDrawer);
      this.addEventListener('click', this._onFacetUpdate);
    }

    _onFacetUpdate(event) {
      event.preventDefault();
      const dataParentSectionSelector = event.target.dataset.parentSectionSelector;
      const target = dataParentSectionSelector ? document.querySelector(dataParentSectionSelector) : event.target;
      const sectionId = target.closest('.shopify-section')?.id.replace('shopify-section-', '');

      if (!sectionId) return;

      const url = new URL(this.href);
      url.searchParams.set('section_id', sectionId);

      this.dispatchEvent(new CustomEvent('facet:update', {
        bubbles: true,
        detail: {
          url
        }
      }));
    }

    async _closeDrawer() {
      this.closest('facet-drawer').hide();
    }
  }

  if (!window.customElements.get('custom-facet-link-clear-filters')) {
    window.customElements.define('custom-facet-link-clear-filters', CustomFacetLinkClearFilters, { extends: 'a' });
  }
});